import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["playlistId"];
import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import CreateOrEditHubspotPlaylistModal from './CreateOrEditHubspotPlaylistModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditHubspotPlaylistButton = _ref => {
  let {
      playlistId
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleEditButtonClick = () => {
    setIsModalOpen(true);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, Object.assign({
      onClick: handleEditButtonClick
    }, buttonProps, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlists.hubspotPlaylists.editDetails"
      })
    })), isModalOpen && /*#__PURE__*/_jsx(CreateOrEditHubspotPlaylistModal, {
      action: "edit",
      onClose: () => setIsModalOpen(false),
      playlistId: playlistId
    })]
  });
};
export default EditHubspotPlaylistButton;